import { useCallback, useState } from 'react';

import { openPointsModal } from './pointsIntegration';

/**
 * Custom hook to handle loading state and opening of the points modal.
 * @returns [isLoadingPtsModal, handleOpenPointsModal]
 */
export function usePointsModal(): [boolean, () => Promise<void>] {
  const [isLoadingPtsModal, setIsLoadingPtsModal] = useState(false);

  const handleOpenPointsModal = useCallback(async () => {
    setIsLoadingPtsModal(true);
    await openPointsModal();
    setIsLoadingPtsModal(false);
  }, []);

  return [isLoadingPtsModal, handleOpenPointsModal];
}
